<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-title align-items-start flex-column">
        <span class="font-weight-bolder text-dark">{{ getTitle() }}</span>
      </h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="createPasswordForm">
    <div class="card-body">
      <div class="form-group">
        <kt-alert
          *ngIf="hasFormErrors"
          type="warn"
          [duration]="30000"
          [showCloseButton]="true"
          (closeAl)="onAlertClose()"
        >
          <span translate="GLOBAL.FORM_ERROR"></span>
        </kt-alert>
        <div class="row">
          <div class="col-12 kt-margin-bottom-20-mobile mb-4" *ngIf="fromResetPassButton">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'AUTH.INPUT.NEW_PASSWORD' | translate }}</mat-label>
              <input
                matInput
                type="password"
                id="password"
                autocomplete="off"
                placeholder="{{ 'AUTH.INPUT.NEW_PASSWORD' | translate }}"
                formControlName="password"
              />

              <mat-error *ngIf="isControlHasError('password', 'required')">
                <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
              </mat-error>
              <mat-error *ngIf="isControlHasError('password', 'pattern')">
                <strong>{{ 'AUTH.VALIDATION.PATTERN_PASSWORD' | translate }} </strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 kt-margin-bottom-20-mobile mb-4" *ngIf="fromResetPassButton">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'AUTH.INPUT.CONFIRM_PASSWORD' | translate }}</mat-label>
              <input
                matInput
                type="password"
                id="confirmPassword"
                autocomplete="off"
                placeholder="{{ 'AUTH.INPUT.CONFIRM_PASSWORD' | translate }}"
                formControlName="confirmPassword"
              />
              <mat-error *ngIf="isControlHasError('confirmPassword', 'required')">
                <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
              </mat-error>
              <mat-error *ngIf="f.confirmPassword.invalid">
                <strong>{{ 'AUTH.VALIDATION.NOT_MATCH' | translate }} </strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 kt-margin-bottom-20-mobile" *ngIf="!fromResetPassButton">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>Username</mat-label>
              <input matInput placeholder="Username" maxlength="16" formControlName="firstField" />
              <mat-error *ngIf="isControlHasError('firstField', 'required')">
                <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
              </mat-error>
              <mat-error *ngIf="isControlHasError('firstField', 'pattern')">
                <strong>{{ 'AUTH.VALIDATION.INVALID' | translate }}</strong>
              </mat-error>
              <mat-error *ngIf="!createPasswordForm.controls.firstField.valid">
                <strong>{{ error }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            (click)="onCloseClick()"
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Cancel"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <ng-template ngxPermissionsOnly="canEditTask">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="onSubmit()"
              matTooltip="Save"
            >
              <span translate="GLOBAL.SAVE">Save</span>
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </form>
</div>
